<template>
  <div class="heji-item">
    <div class="heji-tit-line clearfix">
      <div class="tit">{{item.collectionName}}</div>
      <div class="trigger" @click="toggle">{{show ? '收起' : '查看'}}剧集</div>
      <el-button class="buy-button" type="danger" :disabled="item.isAllBuyed == 1" v-on:click="hejiBuy(item)" size="mini">￥{{item.currentPrice}}</el-button>
    </div>
    <ul class="heji-list clearfix" v-if="show">
      <li class="ji-itm clearfix" v-for="(itm, idx) in item.vcdList" :key="idx">
        <span class="tit">{{itm.sectionName}}</span>
        <span class="buy" v-if="itm.isBuyed == 1">已购买</span>
        <span class="buy ys" v-else-if="!itm.videoId">预售</span>
      </li>
      <!--<li class="ji-itm" v-for="(itm, idx) in item.vcdList" :key="idx">{{itm.sectionName}} &#45;&#45;{{itm.isBuyed}}</li>-->
    </ul>
  </div>
</template>

<script>
export default {
  name: 'heji',
  props: ['item'],
  data () {
    return {
      show: true
    }
  },
  methods: {
    toggle () {
      this.show = !this.show
    },
    hejiBuy(item){

      if(item.isAllBuyed ==2){
        this.$alert('该专辑有已购买剧集，是否继续购买？', {
          lockScroll: false,
          confirmButtonText: '确定',
          callback: action => {
            console.log(action)
            if(action == 'confirm'){
              this.toBuy(item)
            }else {
              return false
            }
          }
        });
        return false
      }else {
        this.toBuy(item)
      }



    },
    toBuy(item){
      let vcId = item.id
      let vcdList = item.vcdList
      this.$parent.$options.parent.orderList = []
      vcdList.forEach(vc =>{
        this.$parent.$options.parent.orderList.push(vc.sectionId);
      })

      this.$parent.$options.parent.setCookie('payVcId',vcId)
      this.$parent.$options.parent.buyHeji()
    }
  }
}
</script>


<style scoped lang="less">
  .heji-item{
    margin: 10px 0;
    padding: 10px;
    box-shadow: 0 0 5px #999;
    border-radius: 5px;
    .heji-tit-line{
      position: relative;
      height: 28px;
      line-height: 28px;
      .tit{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        float: left;
        max-width: calc(100% - 135px);
        font-weight: bold;
      }
      .trigger{
        float: left;
        width: 60px;
        margin-left: 5px;
        color: #409eff;
        cursor: pointer;
      }
      .buy-button{
        position: absolute;
        right: 0;
        top: 0;
        width: 65px;
      }
    }
    .heji-list{
      .ji-itm{
        float: left;
        width: 33.33%;
        margin: 8px 0;
        line-height: 22px;
        .tit{
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          float: left;
          max-width: calc(100% - 60px);
        }
        .buy{
          float: left;
          width: 50px;
          margin: 0 5px;
          color: #fff;
          font-size: 12px;
          text-align: center;
          background: #F56C6C;
          border-radius: 4px;
          &.ys {
            background: rgba(64,158,255, .6);
          }
        }
      }
    }
  }
  @media screen and (max-width: 1000px) {
    .heji-item{
      .heji-list{
        .ji-itm{
          width: 100%;
          padding-right: 0;
        }
      }
    }
  }
</style>
